import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, Smiley, Users } from '@phosphor-icons/react';
import { api } from '@/lib/api';

export const ROLE_KEY = 'unmanip_role';
export const getRole = () => localStorage.getItem(ROLE_KEY) || '';
export function setRole(role) {
  localStorage.setItem(ROLE_KEY, role);
  window.dispatchEvent(new CustomEvent('unmanip:role', { detail: role }));
  api.put('/prefs/role', { role }).catch(() => {});
}

// First-open question: Parent/Guardian or Kid/Teen. Shown once; changeable in Settings.
export default function RoleGate({ children }) {
  const [role, setRoleState] = useState(() => getRole());
  const nav = useNavigate();
  if (role) return children;

  const choose = (r) => {
    setRole(r);
    setRoleState(r);
    nav(r === 'parent' ? '/link' : '/link', { replace: true });
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-zinc-950 px-5" data-testid="role-gate">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center border border-zinc-700 bg-zinc-900">
            <ShieldCheck weight="fill" className="h-5 w-5 text-emerald-400" />
          </div>
          <div className="leading-none">
            <div className="font-sans text-lg font-black tracking-tighter text-zinc-100">unmanipulated</div>
            <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500">one quick question</div>
          </div>
        </div>

        <h1 className="mt-8 font-sans text-3xl sm:text-4xl font-black tracking-tighter leading-[0.95] text-zinc-100">
          Who's using this?
        </h1>
        <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
          We'll set things up the right way for you. You can change this any time in Settings.
        </p>

        <div className="mt-8 grid gap-3">
          <button onClick={() => choose('parent')} data-testid="role-parent"
            className="group flex items-center gap-4 border border-zinc-800 bg-zinc-900/60 p-5 text-left hover:border-emerald-500 transition-colors">
            <Users weight="fill" className="h-8 w-8 shrink-0 text-emerald-400" />
            <span>
              <span className="block font-sans text-lg font-black tracking-tight text-zinc-100">I'm a Parent / Guardian</span>
              <span className="block mt-1 text-xs text-zinc-400">Protect my family · Family Guardian, alerts, evidence vault</span>
            </span>
          </button>
          <button onClick={() => choose('child')} data-testid="role-child"
            className="group flex items-center gap-4 border border-zinc-800 bg-zinc-900/60 p-5 text-left hover:border-emerald-500 transition-colors">
            <Smiley weight="fill" className="h-8 w-8 shrink-0 text-amber-400" />
            <span>
              <span className="block font-sans text-lg font-black tracking-tight text-zinc-100">I'm a Kid / Teen</span>
              <span className="block mt-1 text-xs text-zinc-400">Check messages, spot bullying & scams, stay safe</span>
            </span>
          </button>
        </div>

        <p className="mt-6 text-[11px] text-zinc-600">Nothing you analyze is ever stored. Burn after reading.</p>
      </div>
    </div>
  );
}
